module.exports = "./img/0ab11e0edfbdb755ef7f96ecc7db5642.png";